import React, { useState } from 'react';
import { useItemSearch, SearchResult } from './SiItemsBreakdown';

const slug = (s) => String(s).replace(/[^a-zA-Z0-9]+/g, '-');

export default function SiItemSearch({ picked, onToggle, onOpen }) {
  const [q, setQ] = useState('');
  const { res, busy, err } = useItemSearch(q, '12m');
  const allOn = res.length > 0 && res.every(r => picked.includes(r.item));
  const tickAll = () => res.forEach(r => { if (allOn || !picked.includes(r.item)) onToggle(r.item); });
  return (
    <div className="si-sr" data-testid="si-item-search">
      <input className="input" data-testid="si-item-search-input" placeholder="Search any NetSuite item by code or name (e.g. HAL5G2 WH) — tick results to combine" value={q} onChange={e => setQ(e.target.value)} />
      {busy && <div className="si-fc-note" style={{ marginLeft: 0 }} data-testid="si-item-search-busy">Searching NetSuite…</div>}
      {err && <div className="si-error" data-testid="si-item-search-error">{err}</div>}
      {!busy && q.trim().length >= 2 && !err && res.length === 0 && <div className="si-fc-note" style={{ marginLeft: 0 }} data-testid="si-item-search-empty">No NetSuite items match “{q}”.</div>}
      {res.length > 0 && (
        <div className="si-sr-list" data-testid="si-item-search-results">
          <div className="si-sr-row">
            <input type="checkbox" checked={allOn} onChange={tickAll} data-testid="si-item-search-pick-all" aria-label="Select all results" />
            <span className="si-fc-note" style={{ marginLeft: 0 }}>{res.length} item{res.length === 1 ? '' : 's'} · Q / O = quoted / ordered qty, last 12 months · click a code for its breakdown</span>
          </div>
          {res.map(r => (
            <SearchResult key={r.item} r={r} testid={'si-sr-' + slug(r.item)} checked={picked.includes(r.item)}
              onToggle={() => onToggle(r.item)} onOpen={() => onOpen(r.item)} />
          ))}
        </div>
      )}
    </div>
  );
}
